<!-- About us Start -->
<section class="section why-choose-us" id="who-we-are">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-9 col-md-8">
        <div class="title text-center mb-5">
          <h1 class="font-weight-normal text-dark" style="margin-top:6rem !important">WHO ARE WE ?</h1>
          <p>
            An innovative technology solution enterprise with 10 years of experience providing outsourced software
            development
            services to 100+ clients across the globe.
          </p>
          <p>
            Our competencies cover the entire gamut of technological solutions and services including infrastructure,
            applications,
            engineering, and business processes.
          </p>
          <p>
            We are headquartered in Dallas, Texas – USA; with our Africa HQ in Accra - Ghana, West Africa.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About us End -->
